import React, { Component } from "react";
import _ from "lodash";
import TextField from '@material-ui/core/TextField';
import AnalyticsByProductTable from "components/AnalyticsByProductTable";
import AnalyticsByMerchantTable from "components/AnalyticsByMerchantTable";
import Select from 'react-select';

const { DateTime } = require("luxon");


class AnalyticsByPerformance extends Component {
    constructor(props) {
        super(props);

        this.tabSelectOptions = {
            product: {
                value: 1,
                label: "Performance by Product",
            },
            merchant: {
                value: 2,
                label: "Performance by Merchant"
            },
        } 

        this.state = {
            startDate: DateTime.utc().minus({ months: 1 }).startOf('day'),
            endDate: DateTime.utc().startOf('day'),
            tab: 1,
            tabSelectOptions: {
                options: [
                    this.tabSelectOptions.product,
                    this.tabSelectOptions.merchant,
                ],
                defaultValue: this.tabSelectOptions.product,
                currentValue: this.tabSelectOptions.product,
            },
        };
    }

    componentDidMount = async () => {
        await this.props.getAnalytics(this.state.startDate, this.state.endDate);
    }

    componentDidUpdate = (prevProps, prevState) => {
        if (prevState.startDate !== this.state.startDate || prevState.endDate !== this.state.endDate) {
            if (this.state.startDate <= this.state.endDate) {
                this.setState({ dateError: false });
                if (this.state.tab === 1) {
                    this.props.getAnalytics(this.state.startDate, this.state.endDate);
                } else {
                    this.props.getMerchantAnalytics(this.state.startDate, this.state.endDate);
                }
            } else {
                this.setState({ dateError: true });
            }
        }
        if (prevState.tab !== this.state.tab) {
            if (this.state.tab === 1) {
                this.props.getAnalytics(this.state.startDate, this.state.endDate);
            } else {
                this.props.getMerchantAnalytics(this.state.startDate, this.state.endDate);
            }
        }
        
    }

    handleTabSortSelect = async (e) => {
        const tab = e.value;
        let tabSelectOptions = {...this.state.tabSelectOptions};
        tabSelectOptions.currentValue = e;
        this.props.resetPerformanceTabs();
        this.setState({ tab,  tabSelectOptions });
    }


    handleStartDateChange = (event) => {
        const startDate = DateTime.fromISO(event.target.value).toUTC().startOf('day');
        this.setState({
            startDate
        });
    };

    handleEndDateChange = (event) => {
        const endDate = DateTime.fromISO(event.target.value).toUTC().startOf('day');
        this.setState({
            endDate
        });
    };

    handleWeekToDate = () => {
        const startDate = DateTime.utc().minus({ weeks: 1 }).startOf('day');
        const endDate = DateTime.utc().startOf('day');
        this.setState({ startDate, endDate });
    };

    handleMonthToDate = () => {
        const startDate = DateTime.utc().minus({ months: 1 }).startOf('day');
        const endDate = DateTime.utc().startOf('day');
        this.setState({ startDate, endDate });
    };

    handleYearToDate = () => {
        const startDate = DateTime.utc().minus({ years: 1 }).startOf('day');
        const endDate = DateTime.utc().startOf('day');
        this.setState({ startDate, endDate });
    };

    handleSortSelect = async (e) => {
        await this.props.handleSortSelect(e);
    }

    handleMerchantSortSelect = async (e) => {
        await this.props.handleMerchantSortSelect(e);
    }

    render() {
        return (
            <div className="container pt-0 pb-5 px-0 px-md-3" style={{ display: this.props.display ? "" : "none", fontFamily: "'Archivo', sans-serif" }}>
                <div className="pt-3">
                    <div className="search-block">
                        <div className={`mx-0 d-flex justify-content-between ${["sm"].includes(this.props.deviceSize) ? "ml-2 mr-2" : ""}`}>
                            <div className="" style={{ position: "relative", top: "0", width: "250px" }}>
                                <Select
                                    isMulti={false}
                                    isClearable={false}
                                    isSearchable={false}
                                    blurInputOnSelect={true}
                                    captureMenuScroll={true}
                                    value={this.state.tabSelectOptions.currentValue}
                                    onChange={(e) => { this.handleTabSortSelect(e) }}
                                    options={this.state.tabSelectOptions.options} />
                            </div>
                            <div className="d-flex">
                                <div onClick={this.handleWeekToDate} style={{ cursor: "pointer", width: '35px', height: '35px', backgroundColor: 'white', border: '1px solid lightgray',  display: 'flex', justifyContent: 'center', alignItems: 'center', borderRadius: '4px 0 0 4px' }}>1w</div>
                                <div onClick={this.handleMonthToDate} style={{ cursor: "pointer", width: '35px', height: '35px', backgroundColor: 'white', borderTop: '1px solid lightgray', borderBottom: '1px solid lightgray', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>1m</div>
                                <div onClick={this.handleYearToDate} style={{ cursor: "pointer", width: '35px', height: '35px', backgroundColor: 'white', border: '1px solid lightgray', display: 'flex', justifyContent: 'center', alignItems: 'center', borderRadius: '0 4px 4px 0' }}>1y</div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="d-flex justify-content-end" style={{ position: 'relative', top: '3px', right: '0' }}>
                    
                </div>

                <p className="ml-3 pt-3 mb-0" style={{ color: "red", display: this.state.dateError ? "" : "none" }}>Start Date must be before the End Date</p>

                <div className={`d-flex justify-content-${["sm"].includes(this.props.deviceSize) ? "between" : "start"} ${["sm"].includes(this.props.deviceSize) ? "mx-3" : ""} pt-3`} style={{ gap: ["sm"].includes(this.props.deviceSize) ? "" : "30px", fontFamily: "'Archivo',sans-serif" }}>
                    <div className="d-flex flex-column">
                        <label className="mb-0">Start Date:</label>
                        <TextField
                            id="start-date"
                            type="date"
                            value={this.state.startDate.toISODate()}
                            onChange={this.handleStartDateChange}
                            InputLabelProps={{
                                shrink: true,
                            }}
                            InputProps={{
                                style: { fontFamily: "'Archivo', sans-serif" }
                            }}                        />
                    </div>
                    <div className="d-flex flex-column">
                        <label className="mb-0">End Date:</label>
                        <TextField
                            id="end-date"
                            type="date"
                            value={this.state.endDate.toISODate()}
                            onChange={this.handleEndDateChange}
                            InputLabelProps={{
                                shrink: true,
                            }}
                            InputProps={{
                                style: { fontFamily: "'Archivo', sans-serif" }
                            }}
                        />
                    </div>
                </div>                    

                {
                    this.state.tab === 1 ?
                        <AnalyticsByProductTable
                            loggedInUser={this.props.loggedInUser}
                            analytics={this.props.analytics}
                            analyticsLoading={this.props.analyticsLoading}
                            getAnalytics={this.props.getAnalytics}
                            date={this.props.date}
                            deviceSize={this.props.deviceSize}
                            handleGetLink={this.props.handleGetLink}
                            handleSortSelect={this.props.handleSortSelect}
                            selectOptions={this.props.selectOptions}
                            sortDescending={this.props.sortDescending}
                            resetPerformanceTabs={this.props.resetPerformanceTabs}
                            startDate={this.state.startDate}
                            endDate={this.state.endDate}
                            userChanged={this.props.productUserChanged ?? false}
                            aggregateChanged={this.props.aggregateChanged}
                            display={this.props.display}
                            browseChanged={this.props.browseChanged}
                        />
                        :
                        this.state.tab === 2 ?
                            <AnalyticsByMerchantTable
                                loggedInUser={this.props.loggedInUser}
                                merchantAnalytics={this.props.merchantAnalytics}
                                merchantAnalyticsLoading={this.props.analyticsByMerchantLoading}
                                getMerchantAnalytics={this.props.getMerchantAnalytics}
                                date={this.props.date}
                                deviceSize={this.props.deviceSize}
                                handleGetLink={this.props.handleGetLink}
                                handleMerchantSortSelect={this.handleMerchantSortSelect}
                                merchantSelectOptions={this.props.merchantSelectOptions}
                                merchantSortDescending={this.props.merchantSortDescending}
                                resetPerformanceTabs={this.props.resetPerformanceTabs}
                                startDate={this.state.startDate}
                                endDate={this.state.endDate}
                                userChanged={this.props.merchantUserChanged ?? false}
                                aggregateChanged={this.props.aggregateChanged}
                                display={this.props.display}
                                browseChanged={this.props.browseChanged}
                                />
                            :
                    <></>
                }                
            </div>
        );
    }
}

export default AnalyticsByPerformance;